import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "../stylesheets/application.css"
import { startAnalytics } from "../src/analytics"

startAnalytics()

document.addEventListener("change", (event) => {
  const select = event.target.closest("[data-framework-select]")
  if (!select || !select.value) return

  window.location.assign(select.value)
})

document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-copy-code]")
  if (!button) return

  const card = button.closest("[data-code-card]")
  const code = card?.querySelector("code")?.innerText
  if (!code) return

  try {
    await navigator.clipboard.writeText(code)
    button.innerText = "Copied"
    window.setTimeout(() => {
      button.innerText = "Copy"
    }, 1400)
  } catch (_error) {
    button.innerText = "Select"
  }
})

// "Copy link" on /brand: the URL to copy is on the button itself, so one
// handler serves every asset card.
document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-copy-text]")
  if (!button) return

  const label = button.innerText
  try {
    await navigator.clipboard.writeText(button.dataset.copyText)
    button.innerText = "Copied"
  } catch (_error) {
    button.innerText = "Copy failed"
  }
  window.setTimeout(() => {
    button.innerText = label
  }, 1400)
})
